import { render, staticRenderFns } from "./StoredBrandQueryResult.vue?vue&type=template&id=03143f31&scoped=true&"
import script from "./StoredBrandQueryResult.vue?vue&type=script&lang=ts&"
export * from "./StoredBrandQueryResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03143f31",
  null
  
)

export default component.exports